/* Racer survey 2027: the page script for sections/msc-racer-survey.liquid
   (mountainstatescup.com/pages/racer-survey). Founder pick 2026-10-26.

   The page opens only from the personal link in Shawn's email: ?e=<base64url email>&t=<hmac>
   (msc-admin scripts/racer-survey-blast.mjs mints it; #e=…&t=… is read too). The script
     1. reads the link, keeps it for this tab (sessionStorage, so a reload still works) and takes it
        out of the address bar, so the address it names stays out of later page events, shares and
        screenshots;
     2. GET  https://admin-msc.com/api/public/racer-survey?e&t → { ok, answered } (403 = not our link);
     3. POST the same URL { e, t, answers } → { ok: true }. One row per address: answering again
        replaces the first answer, so a retry after a failed or unclear send is always safe.
   The answer values are the endpoint's lists (msc-admin api/_lib/racer-survey.ts); the endpoint
   refuses anything else. Ten questions (his six, and four more the same day); only "Who's
   answering?" is required. */
(function () {
  'use strict';

  var root = document.querySelector('[data-msc-racer-survey]');
  if (!root || root.getAttribute('data-rs-ready') === '1') return;
  root.setAttribute('data-rs-ready', '1');

  var ENDPOINT = root.getAttribute('data-endpoint');
  var STORE_KEY = 'msc-racer-survey-link';
  var LOAD_TIMEOUT_MS = 15000;
  var SEND_TIMEOUT_MS = 20000;
  var LOADING_LINE_AFTER_MS = 800;

  var MSG_SEND_FAILED = "That didn't send. Try again.";
  var MSG_TOO_MANY = 'Too many tries. Wait a minute, then send again.';

  function part(name) { return root.querySelector('[data-rs-' + name + ']'); }
  var form = part('form');
  var panels = {
    closed: part('closed'),
    loading: part('loading'),
    trouble: part('trouble'),
    done: part('done'),
    form: form
  };
  var answeredLine = part('answered');
  var q1 = part('q1');
  var q1Err = part('q1-err');
  var sendBtn = part('send');
  var msg = part('msg');
  var retryBtn = part('retry');
  if (!form || !sendBtn) return;

  var link = null;
  var sending = false;
  var loadingTimer = null;

  // ── States: one panel at a time; the heading stays on every one ──
  function setState(state) {
    var visible = state === 'answered' ? 'form' : state;
    for (var key in panels) {
      if (Object.prototype.hasOwnProperty.call(panels, key) && panels[key]) panels[key].hidden = key !== visible;
    }
    if (answeredLine) answeredLine.hidden = state !== 'answered';
    root.setAttribute('data-rs-state', state);
  }

  // ── The link ──
  function readParams(search) {
    var out = { e: null, t: null };
    if (!search) return out;
    try {
      var q = new URLSearchParams(search);
      out.e = q.get('e');
      out.t = q.get('t');
    } catch (err) { /* no URLSearchParams: the link stays unread */ }
    return out;
  }
  function stripLinkFromAddressBar() {
    try {
      var q = new URLSearchParams(window.location.search);
      q.delete('e');
      q.delete('t');
      var rest = q.toString();
      window.history.replaceState(window.history.state, '', window.location.pathname + (rest ? '?' + rest : ''));
    } catch (err) { /* old browser: the link stays in the address bar, nothing else changes */ }
  }
  function readLink() {
    var p = readParams(window.location.search);
    if (!(p.e && p.t) && window.location.hash.length > 1) p = readParams(window.location.hash.slice(1));
    if (p.e && p.t) {
      try { window.sessionStorage.setItem(STORE_KEY, JSON.stringify({ e: p.e, t: p.t })); } catch (err) { /* private mode */ }
      stripLinkFromAddressBar();
      return { e: p.e, t: p.t };
    }
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(STORE_KEY) || 'null');
      if (saved && typeof saved.e === 'string' && typeof saved.t === 'string') return saved;
    } catch (err) { /* nothing kept */ }
    return null;
  }

  // ── One request with a deadline. Resolves { status, data }; status 0 = no answer. ──
  function request(method, url, body, timeoutMs) {
    return new Promise(function (resolve) {
      var finished = false;
      var controller = null;
      try { controller = new window.AbortController(); } catch (err) { controller = null; }
      var timer = window.setTimeout(function () {
        if (controller) { try { controller.abort(); } catch (err) { /* already done */ } }
        finish({ status: 0, data: null });
      }, timeoutMs);
      function finish(result) {
        if (finished) return;
        finished = true;
        window.clearTimeout(timer);
        resolve(result);
      }
      var opts = { method: method, headers: { Accept: 'application/json' }, credentials: 'omit', cache: 'no-store' };
      if (body) {
        opts.headers['Content-Type'] = 'application/json';
        opts.body = JSON.stringify(body);
      }
      if (controller) opts.signal = controller.signal;
      window.fetch(url, opts)
        .then(function (res) {
          return res.text().then(function (text) {
            var data = null;
            try { data = text ? JSON.parse(text) : null; } catch (err) { data = null; }
            finish({ status: res.status, data: data });
          });
        })
        .catch(function () { finish({ status: 0, data: null }); });
    });
  }

  // ── Load: is this link ours, and has this address answered? ──
  function load() {
    if (!window.fetch || !window.Promise) { setState('trouble'); return; }
    setState('waiting');
    window.clearTimeout(loadingTimer);
    loadingTimer = window.setTimeout(function () {
      if (root.getAttribute('data-rs-state') === 'waiting' && panels.loading) panels.loading.hidden = false;
    }, LOADING_LINE_AFTER_MS);
    var url = ENDPOINT + '?e=' + encodeURIComponent(link.e) + '&t=' + encodeURIComponent(link.t);
    request('GET', url, null, LOAD_TIMEOUT_MS).then(function (r) {
      window.clearTimeout(loadingTimer);
      if (r.status === 200 && r.data && r.data.ok === true) {
        setState(r.data.answered === true ? 'answered' : 'form');
      } else if (r.status === 403) {
        forgetLink();
        setState('closed');
      } else {
        setState('trouble');
      }
    });
  }
  function forgetLink() {
    try { window.sessionStorage.removeItem(STORE_KEY); } catch (err) { /* nothing kept */ }
  }

  // ── The form ──
  function checked(name) {
    var el = form.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : null;
  }
  function checkedAll(name) {
    var els = form.querySelectorAll('input[name="' + name + '"]:checked');
    var out = [];
    for (var i = 0; i < els.length; i++) out.push(els[i].value);
    return out;
  }
  function text(name) {
    var el = form.elements[name];
    var v = el && typeof el.value === 'string' ? el.value.trim() : '';
    return v || null;
  }
  // A picked row turns white. Set from the inputs themselves, so it can never drift from them.
  function syncRows() {
    var rows = form.querySelectorAll('.rs__opt');
    for (var i = 0; i < rows.length; i++) {
      var input = rows[i].querySelector('input[type="radio"], input[type="checkbox"]');
      if (input && input.checked) rows[i].classList.add('is-on');
      else rows[i].classList.remove('is-on');
    }
  }
  function say(line) { msg.textContent = line || ''; }

  form.addEventListener('change', function (ev) {
    syncRows();
    if (ev.target && ev.target.name === 'answeringAs' && q1Err) q1Err.hidden = true;
  });

  // Typing in an "Other" box picks Other.
  function pickOther(ev) {
    var box = ev.target;
    var group = box && box.getAttribute('data-rs-other-of');
    if (!group || !box.value.trim()) return;
    var choice = form.querySelector('input[name="' + group + '"][value="other"]');
    if (choice && !choice.checked) {
      choice.checked = true;
      syncRows();
    }
  }
  form.addEventListener('input', pickOther);

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    if (sending || !link) return;
    say('');

    var answeringAs = checked('answeringAs');
    if (!answeringAs) {
      if (q1Err) q1Err.hidden = false;
      var first = q1 && q1.querySelector('input');
      try { q1.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) { /* old browser */ }
      if (first) { try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); } }
      return;
    }

    var bike = checked('bike');
    var buy = checkedAll('buy');
    var broadcast = checked('broadcastFavorite');
    var brandsShould = checkedAll('brandsShould');
    var offers = checked('offers');
    var answers = {
      answeringAs: answeringAs,
      bike: bike,
      bikeOther: bike === 'other' ? text('bikeOther') : null,
      brands: text('brands'),
      buy: buy,
      buyOther: buy.indexOf('other') >= 0 ? text('buyOther') : null,
      spend: checked('spend'),
      groupSize: checked('groupSize'),
      broadcastFavorite: broadcast,
      broadcastOther: broadcast === 'other' ? text('broadcastOther') : null,
      brandsShould: brandsShould,
      brandsShouldOther: brandsShould.indexOf('other') >= 0 ? text('brandsShouldOther') : null,
      offers: offers === 'yes' ? true : offers === 'no' ? false : null,
      change2027: text('change2027')
    };

    sending = true;
    var label = sendBtn.textContent;
    sendBtn.disabled = true;
    sendBtn.textContent = 'Sending…';
    form.setAttribute('aria-busy', 'true');

    request('POST', ENDPOINT, { e: link.e, t: link.t, answers: answers }, SEND_TIMEOUT_MS).then(function (r) {
      sending = false;
      sendBtn.disabled = false;
      sendBtn.textContent = label;
      form.removeAttribute('aria-busy');
      if (r.status === 200 && r.data && r.data.ok === true) {
        setState('done');
        try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, 0); }
        var done = panels.done;
        if (done) { try { done.focus({ preventScroll: true }); } catch (err) { done.focus(); } }
        return;
      }
      if (r.status === 403) { forgetLink(); setState('closed'); return; }
      say(r.status === 429 ? MSG_TOO_MANY : MSG_SEND_FAILED);
    });
  });

  if (retryBtn) retryBtn.addEventListener('click', function () { if (link) load(); });

  // ── Start ──
  link = readLink();
  if (!link) setState('closed');
  else load();
})();
